<template>
  <section class="error" v-if="errors.length > 0">
    <div v-for="(error, key) in errors" :key="key">
      <p class="error_msg">
        <strong @click="deleteError(key)" class="error_mark">X</strong>
        {{error.msg}}: 
        <strong>{{error.data}}</strong>
      </p>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      errors: []
    };
  },
  methods: {
    deleteError(postion) {
      this.errors.splice(postion, 1);
    }
  },
  sockets: {
    resFail(data) {
      this.errors.push(data);
    }
  }
};
</script>

<style lang="scss">
.error {
  &_msg {
    padding: 2%;
    box-shadow: 0 10px 6px -6px #777;
  }
  &_mark {
    color: red;
  }
}
</style>
